import React, { useState, useEffect } from 'react';
import apiClient from '../../api/axiosConfig';
import { API_ENDPOINTS } from '../../constants';
import { useToast } from '../../contexts/ToastContext';
import MetaTagsUpdater from '../../components/MetaTagsUpdater'; // Import MetaTagsUpdater

function TermsAndConditions() {
  const { addToast } = useToast();
  const [terms, setTerms] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const response = await apiClient.get(API_ENDPOINTS.TERMS_CONDITIONS);
        setTerms(response.data.data);
      } catch (err) {
        setError('Failed to load terms and conditions. Please try again later.');
        addToast('Failed to load terms and conditions.', 'error');
      } finally {
        setLoading(false);
      }
    };

    fetchTerms();
  }, [addToast]);

  if (loading) {
    return (
      <div className="pt-20 text-center text-text-white">
        <MetaTagsUpdater pageKey="TermsAndConditions" />
        Loading terms and conditions...
      </div>
    );
  }

  if (error) {
    return (
      <div className="pt-20 text-center text-red-500">
        <MetaTagsUpdater pageKey="TermsAndConditions" />
        {error}
      </div>
    );
  }

  if (!terms || !terms.content) {
    return (
      <div className="pt-20 text-center text-text-gray">
        <MetaTagsUpdater pageKey="TermsAndConditions" />
        No terms and conditions found.
      </div>
    );
  }

  return (
    <div className="pt-20">
      <MetaTagsUpdater pageKey="TermsAndConditions" />
      <div className="max-w-6xl mx-auto px-5 py-8">
        <h1 className="text-4xl font-bold text-center text-text-white mb-16 relative after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-20 after:h-1 after:bg-accent-red after:rounded-sm after:bottom-[-15px]">
          Terms and Conditions
        </h1>
        <div className="bg-bg-light p-8 rounded-lg shadow-md text-text-gray rich-text-content">
          <div dangerouslySetInnerHTML={{ __html: terms.content }} />
        </div>
      </div>
    </div>
  );
}

export default TermsAndConditions;